import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import SimpleButtonDropdown from '../SimpleButtonDropdown';
import MultipleTooltip from '../MultipleTooltip';
import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader';
import ButtonAction from '../ButtonAction';
import ModalButtonsContainer from '../ModalButtonsContainer';
import textSuggestionsIcon from './Write.svg';
import styles from './styles.module.scss';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../styles/styles';

const ButtonTextSuggestions = ({
                                 fieldName,
                                 currentFieldValue,
                                 textSuggestionsArray = [],
                                 setFieldValue,
                                 disabled,
                               }) => {
  const [show, setShow] = useState(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModal = () => setShow(false);
  const [value, setValue] = useState('');
  const intl = useIntl();

  return (
    <div className={styles.textSuggestionsInteraction}>
      {!disabled
        ?
        <>
          <SimpleButtonDropdown
            drop={'up'}
            id={'dropdown-autoclose-false'}
            title={
              <MultipleTooltip
                id={`textSuggestions-${fieldName}`}
                customIconClassName={styles.triggerButton}
                label={intl.formatMessage({id: 'button-text-suggestions-label', defaultMessage: 'Replace text'})}
                icon={textSuggestionsIcon}
              />
            }
            header={
              <div className={'p-2'}>
                {intl.formatMessage({id: 'button-text-suggestions-header', defaultMessage: 'Selecting a guide text:'})}
              </div>
            }
            items={
              textSuggestionsArray.map(item => {
                return {
                  onClick: (
                    () => {
                      if (currentFieldValue !== item.value) {
                        if (Boolean(currentFieldValue)) {
                          handleShowModal();
                          setValue(`${item.value}`);
                        } else {
                          setFieldValue(fieldName, `${item.value}`);
                        }
                      }
                    }
                  ),
                  itemContent: item.label,
                  disabled: currentFieldValue === item.value,
                  customStyles: 'p-3',
                };
              })
            }
          />
          <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
              <ModalHeader
                header={intl.formatMessage({
                    id: 'ask-if-replace-text-message',
                    defaultMessage: 'There is text in this field, should I replace it or cancel the operation?'
                })}
              />
              <ModalButtonsContainer customClassnames={largeButtonsPadding}>
                <ButtonAction
                  variant={'cancel'}
                  onClick={handleCloseModal}
                  label={intl.formatMessage({id: 'no', defaultMessage: 'No'})}
                  customClassnames={buttonCancel}
                />
                <ButtonAction
                  onClick={() => {
                    setFieldValue(fieldName, value);
                    handleCloseModal();
                  }}
                  useIcon={'/media/common/Check-in-circle_white.svg'}
                  label={intl.formatMessage({id: 'yes', defaultMessage: 'Yes'})}
                  customClassnames={buttonSubmit}
                />
              </ModalButtonsContainer>
          </ModalContainer>
        </>
        : null
      }
    </div>
  );
};

export default ButtonTextSuggestions;